// rtk-query/api.ts
import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from './utils/base-query';

// Define all tags in one place for better organization
export const API_TAGS = {
  User: 'User',
  Onboarding: 'Onboarding',
  RecruiterAgent: 'RecruiterAgent',
  getPositionById: 'getPositionById', // For position-specific tag
  getEmailSender: 'getEmailSender', // For email sender specific tag
  ConversationGroups: 'ConversationGroups',
  Conversation: 'Conversation',
  getConversation: 'getConversation', // For conversation specific tag
  getStreamingMessage: 'getStreamingMessage', // For stream message specific tag
  getPositionSequencePreferencesQuery: 'getPositionSequencePreferencesQuery', // For sequence preferences
  getAccountUsers: 'getAccountUsers',
} as const;

// Create a single API slice
export const api = createApi({
  reducerPath: 'api',
  baseQuery: axiosBaseQuery(),
  tagTypes: Object.values(API_TAGS),
  endpoints: () => ({}), // We'll inject endpoints from separate files
});

// Export hooks will be re-exported from individual endpoint files
export const { reducerPath, reducer: apiReducer, middleware: apiMiddleware } = api;
